import React, { useContext, useState } from 'react';
import { AppGeneralContext } from 'shared/GeneralContext/GeneralContext';
import { useAuth } from 'shared/auth';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { Button } from 'components/atoms';
import CircularProgress from '@mui/material/CircularProgress';
import { postResetEmail, getVerificationCode } from 'api/calls'; // Import the function for generating the code
import axios from 'axios';

import { ModalType } from 'components/types/types';

import { Loader } from 'components/atoms';
import { emailRegex } from 'shared/const';

Yup.addMethod(Yup.string, 'email', function (message: string) {
  return this.matches(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/, message);
});

const ResetEmail = () => {
  const {
    setresetEmailisOPen,
    getUserData,
    loginType,
    setModal,
    setErrorModal,
    setClosedModal
  } = useContext(AppGeneralContext);
  //const { saveAuth } = useAuth();
  const [isSubmitting, setSubmitting] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [verificationCodeGenerated, setVerificationCodeGenerated] = useState<boolean>(false);

  const resetEmailSchema = Yup.object().shape({
    newEmail: Yup.string()
    .matches(emailRegex, 'Wrong email format')
    .required('Please enter your new email address.'),
    verifCode: Yup.string().required('Please enter the verification code'),
    confirmEmail: Yup.string().when("newEmail", {
      is: (newEmail: string) => newEmail && newEmail.length > 0,
      then: Yup.string()
        .oneOf([Yup.ref('newEmail'), null], 'Emails do not match')
        .required('Please confirm your new email address.'),
    }),
    
  });

  const formikResetEmail = useFormik({
    initialValues: {"newEmail": "", "confirmEmail": "", "verifCode": "" },
    validationSchema: resetEmailSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      //console.log("jkjgkjkkj")
      setSubmitting(true);

      postResetEmail(values).then(async (res) => {   
        formikResetEmail.setFieldValue("newEmail", "");
        formikResetEmail.setFieldValue("confirmEmail", "");
        formikResetEmail.setFieldValue("verifCode", "");
        setresetEmailisOPen(false);

        setSubmitting(false);

        if (!res.isSuccess || !res.response) {
          setErrorModal(res.error);
          setSubmitting(false);
          return;
        }


        if (loginType) {
          const reloaded = await getUserData(loginType);
          if (reloaded) {
            setClosedModal();
          }
        }

        setModal({ isOpen: true, type: ModalType.info, title: "Reset email", message: "Your email has been reset." });
      })
    }
  });

  const generateVerificationCode = async () => {
    setIsLoading(true);
    const response = await getVerificationCode();
    if (response.error) {
      setIsLoading(false); // Stop loading if there's an error
      return;
    }
    setVerificationCodeGenerated(true);
    setIsLoading(false);
  };

  return (
    <div className=''>
      <div className="d-flex align-items-center">
        <h1 className='text-center'>Reset Email</h1>
      </div>
      <div className="tx-white">
        {/* Show loader while loading */}
        {isLoading && (
          <div style={{ height: "60vh" }} className="d-flex justify-content-center align-items-center">
            <Loader />
          </div>
        )}
        {/* Button to generate verification code */}
        {!verificationCodeGenerated && !isLoading && ( // Show the button only if verification code is not generated and not loading
          <div className='d-flex justify-content-end mt-4'>
            <Button
              disabled={isSubmitting}
              icon={isSubmitting ? <CircularProgress style={{ height: "20px", width: "20px", marginRight: "10px" }} color="inherit" /> : <></>}
              onClick={generateVerificationCode} // Call the function to generate the verification code
              className='mt-1'
              color='var(--white)'
              background='var(--primary)'
              borderColor='var(--primary)'
              fontWeight={'800'}
              uppercase primary text='Generate Verification Code'
            />
          </div>
        )}

        {/* Form for resetting email */}
        {verificationCodeGenerated && !isLoading && ( // Show the form only if verification code is generated and not loading
          <form onSubmit={formikResetEmail.handleSubmit} className='mb-5' autoComplete='off' id='resetEmail'>
            {/* Input for verification code */}
            <div className='col-xs-12 flex-grow-1'>
              <label className='text-black mt-3' htmlFor="VerifCode">Verification Code</label>
              <input
                autoComplete="code Generate"
                placeholder='Enter the Code recevied in your Old Email'
                {...formikResetEmail.getFieldProps('verifCode')}
                className="form-input"
                type="text"
                onChange={formikResetEmail.handleChange}
                onBlur={() => formikResetEmail.setFieldTouched("verifCode", true)}
                value={formikResetEmail.values.verifCode}
                name="verifCode"
              />
              {formikResetEmail.errors.verifCode && <div className='text-error' id="verifCode">{}</div>}
            </div>

            {/* Input for new email */}
            <div className='col-xs-12 flex-grow-1'>
              <label className='text-black mt-3' htmlFor="newEmail">New email</label>
              <input
                autoComplete="email"
                placeholder='New email'
                {...formikResetEmail.getFieldProps('newEmail')}
                className="form-input"
                type="text"
                onChange={formikResetEmail.handleChange}
                onBlur={() => formikResetEmail.setFieldTouched("newEmail", true)}
                value={formikResetEmail.values.newEmail}
                name="newEmail"
              />
              {formikResetEmail.errors.newEmail && formikResetEmail.touched.newEmail && <div className='text-error' id="newEmail">{formikResetEmail.errors.newEmail}</div>}
            </div>

            {/* Input for confirming new email */}
            <div className='col-xs-12 flex-grow-1'>
              <label className='text-black mt-3' htmlFor="confirmEmail">Confirm Email</label>
              <input
                autoComplete="email"
                placeholder='Confirm email'
                {...formikResetEmail.getFieldProps('confirmEmail')}
                className="form-input"
                type="text"
                onChange={formikResetEmail.handleChange}
                onBlur={() => formikResetEmail.setFieldTouched("confirmEmail", true)}
                value={formikResetEmail.values.confirmEmail}
                name="confirmEmail"
              />
              {formikResetEmail.errors.confirmEmail && formikResetEmail.touched.confirmEmail && <div className='text-error' id="confirmEmail">{formikResetEmail.errors.confirmEmail}</div>}
            </div>

            <div className='d-flex justify-content-end mt-4'>
              <Button
                disabled={isSubmitting}
                icon={isSubmitting ? <CircularProgress style={{ height: "20px", width: "20px", marginRight: "10px" }} color="inherit" /> : <></>}
                onClick={() => {
                  formikResetEmail.handleSubmit()
                }}
                type="submit"
                className='mt-1'
                color='var(--white)'
                background='var(--primary)'
                borderColor='var(--primary)'
                fontWeight={'800'}
                uppercase
                primary
                text='Save'
              />
            </div>
          </form>
        )}
      </div>
    </div>
  )
}

export default ResetEmail;
